import { useFormik } from 'formik'
import * as Yup from 'yup'
import { FormattedMessage, useIntl } from 'react-intl'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import FormikTextField from '../../../../shared/components/formik/FormikTextField'

const CRON_EXPRESSION_REGEX = /^(\*|([0-9]|[1-5][0-9])|\*\/([0-9]|[1-5][0-9])) (\*|([0-9]|1[0-9]|2[0-3])|\*\/([0-9]|1[0-9]|2[0-3])) (\*|([1-9]|[12][0-9]|3[01])|\*\/([1-9]|[12][0-9]|3[01])) (\*|([1-9]|1[0-2])|\*\/([1-9]|1[0-2])) (\*|[0-6]|\*\/[0-6])$/

const CronJobForm = ({ cronJob, createCronJob, updateCronJob, onSuccess, onCancel }) => {
  const intl = useIntl()
  const isEditMode = Boolean(cronJob)

  const validationSchema = Yup.object({
    cronExpression: Yup.string()
      .required(intl.formatMessage({ id: 'login.error.required' }))
      .matches(CRON_EXPRESSION_REGEX, intl.formatMessage({ id: 'cronJobs.form.cronExpressionHelperText' })),
    command: Yup.string()
      .required(intl.formatMessage({ id: 'login.error.required' })),
  })

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      cronExpression: cronJob?.cronExpression || '',
      command: cronJob?.command || '',
    },
    validationSchema,
    onSubmit: (values, { setSubmitting, setStatus }) => {
      const cronJobData = {
        serviceCronJob: {
          cronExpression: values.cronExpression,
          command: values.command,
        }
      }

      const apiCall = isEditMode
        ? updateCronJob(cronJob.id, cronJobData)
        : createCronJob(cronJobData)

      apiCall
        .then(() => {
          onSuccess()
        })
        .catch((err) => {
          setStatus(err.message || 'Error saving cron job')
        })
        .finally(() => {
          setSubmitting(false)
        })
    }
  })

  return (
    <Box component="form" onSubmit={formik.handleSubmit}>
      <FormikTextField
        formik={formik}
        name="cronExpression"
        label={<FormattedMessage id="cronJobs.form.cronExpressionLabel" />}
        autoFocus
      />

      <Box sx={{ mt: 2 }}>
        <FormikTextField
          formik={formik}
          name="command"
          label={<FormattedMessage id="cronJobs.form.commandLabel" />}
        />
      </Box>

      {formik.status && (
        <Typography color="error" sx={{ mt: 2 }}>
          {formik.status}
        </Typography>
      )}

      <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
        <Button
          variant="outlined"
          onClick={onCancel}
          disabled={formik.isSubmitting}
        >
          <FormattedMessage id="app.actions.cancel.label" />
        </Button>
        <Button
          color="primary"
          variant="contained"
          type="submit"
          disabled={formik.isSubmitting}
        >
          <FormattedMessage id="cronJobs.form.submitButton" />
        </Button>
      </Box>
    </Box>
  )
}

export default CronJobForm
